import * as React from "react";
import Moment from "react-moment";
import { useCoreFacade } from "../../../core/facades/Core.facade";
import PrwcRoundedTextIconButton from "../../../ui/widgets/custom/buttons/PrwcRoundedTextIconButton";
import "./NotificationItem.scss";

const NotificationItem = (props: any) => {
  const { data, onDismiss } = props;
  const coreFacade = useCoreFacade();

  const handleOnDismiss = (notificationId: number) => {
    onDismiss(notificationId);
  };

  return (
    <div className="flex px-2 py-1 my-2 border-l-4 cursor-pointer notification-item border-gray-50 hover:border-green-400 w-80 bg-gray-50">
      <div className="flex items-center mr-3">
        <span className="flex items-center justify-center w-8 h-8 font-semibold text-gray-700 bg-gray-300 rounded-full cursor-pointer">
          {data &&
            data.user &&
            coreFacade.getInitialsOfFullName(
              data.user.firstName,
              data.user.lastName
            )}
        </span>
      </div>
     <div className="flex justify-between w-full">
      <div className="w-10/12">
        <div className="font-semibold text-blue-700">{data?.title}</div>
        <div className="text-sm text-gray-500">{data?.message}</div>
        <div className="mt-1 text-xs font-semibold text-gray-400">
          <Moment fromNow>{data?.date}</Moment>
        </div>
      </div>
      <div className="dismiss-button">
        <div className="flex items-center h-full">
          <PrwcRoundedTextIconButton
            onClick={() => handleOnDismiss(data.id)}
            icon="pi pi-times"
          ></PrwcRoundedTextIconButton>
        </div>
      </div>
      </div>
    </div>
  );
};

export default NotificationItem;
